import { useEffect, useRef, useState } from "react";
import { MyIngredientsViewModel } from "../../../viewmodels/setup/myIngredients/MyIngredientsViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";

function MyIngredients(props) {
  const { addSnackbar, logout } = props;
  const {
    emptyModal,
    setEmptyModelOpen,
    getMyIngredients,
    getProductTypes,
    getUnitOfMeasuresForDropdown,
    loading,
    myIngredients,
    openAddMyIngredientSlideOver,
    setSlideOver,
    slideOver,
    viewMyIngredientDetails,
    askDeleteMyIngredient,
  } = MyIngredientsViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getMyIngredients(null, currentPage);
    getProductTypes();
    getUnitOfMeasuresForDropdown();
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getMyIngredients(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getMyIngredients(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="My Ingredients"
        description="Manage internal ingredient records used in formulas and production setup."
        searchPlaceholder="Search ingredients by name"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          { label: "Add Ingredient", onClick: openAddMyIngredientSlideOver },
          auditHistoriesSetupAction("bom-items"),
        ]}
        loading={loading}
        tableColumns={["PLU", "Name", "Unit of measure"]}
        totalRecords={myIngredients.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable
          columns={["PLU", "Name", "Unit of measure"]}
          emptyText="No ingredients found."
        >
          {myIngredients.data?.map((item, index) => (
            <tr key={item.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{item.plu}</SetupTd>
              <SetupTd muted={true}>{item.name}</SetupTd>
              <SetupTd muted={true}>
                {item.unit_of_measure?.label ?? "—"}
              </SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => viewMyIngredientDetails(item, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <AuditActionLink
                  slug="bom-items"
                  id={item.id}
                  name={item.name}
                  className="ml-2"
                />
                <button
                  type="button"
                  onClick={() => askDeleteMyIngredient(item, index)}
                  className="ml-2 inline-flex min-w-[68px] justify-center rounded-lg border border-[#FECACA] bg-white px-3 py-1.5 text-sm font-semibold text-[#DC2626] shadow-sm transition hover:border-[#FCA5A5] hover:bg-[#FEF2F2]"
                >
                  Delete
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyIngredients),
);
